import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import MobileNav from './MobileNav';
import BrandLogo from './BrandLogo';
import './Header.css';
import { getAppPage, PUBLIC_NAV_ITEMS, ROUTES } from './navigation';
import { logEvent } from '../utils/logger';

const demoSchedulingUrl = 'https://calendly.com/sayable-ai/introduction';

function Header({ checkLogin, logout, orgMember, appView = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const loggedInUser = checkLogin();
  const currentPage = getAppPage(location.pathname);
  const name = loggedInUser?.first_name || 'Account';
  const initials = `${loggedInUser?.first_name?.[0] || ''}${loggedInUser?.last_name?.[0] || ''}` || 'S';
  const scheduleDemo = source => {
    logEvent({ event: { label: 'Click', data: { value: 'Schedule a Demo', location: source } } });
  };

  return (
    <header className={`header${appView ? ' header-app' : ' header-public'}`}>
      <div className="header-inner">
        <button className="sayable-logo" type="button" onClick={() => navigate(loggedInUser ? '/overview' : '/')} aria-label="Sayable.ai home">
          <BrandLogo className="header-brand-wordmark" decorative />
        </button>

        {appView && <div className="header-page-context"><span className="header-context-divider" /><span>{currentPage.label}</span></div>}

        {!appView && (
          <nav className="header-public-nav" aria-label="Primary navigation">
            {PUBLIC_NAV_ITEMS.map((item) => <NavLink key={item.path} to={item.path}>{item.label}</NavLink>)}
          </nav>
        )}

        <div className="header-actions">
          {loggedInUser ? (
            <>
              <NavLink to="/account" className="header-user-copy account-link" aria-label="Account settings"><strong>{name}</strong><span>Account settings</span></NavLink>
              <span className="header-avatar" aria-hidden="true">{initials.toUpperCase()}</span>
              {!appView && <NavLink className="header-overview" to={ROUTES.overview}>Manage</NavLink>}
              <button className="header-signout" type="button" onClick={logout}>Sign out</button>
            </>
          ) : (
            <>
              <NavLink className="header-signin" to="/signin">Sign in</NavLink>
              {!appView && <a className="header-schedule-demo" href={demoSchedulingUrl} target="_blank" rel="noreferrer" onClick={() => scheduleDemo('header')}>Schedule a demo</a>}
              <NavLink className="header-get-started" to="/signup">Get started</NavLink>
            </>
          )}
        </div>

        <MobileNav loggedInUser={loggedInUser} orgMember={orgMember} logout={logout} appView={appView} demoSchedulingUrl={demoSchedulingUrl} onScheduleDemo={scheduleDemo} />
      </div>
    </header>
  );
}

export default Header;
